import { createStore, applyMiddleware } from "redux";
import { routerMiddleware } from "react-router-redux";
import logger from "redux-logger";
import reducers from "../reducers";

import { createEpicMiddleware } from "redux-observable";
import { rootEpic } from "../epics";

const epicMiddleware = createEpicMiddleware();
const createHistory = require("history").createBrowserHistory;
const history = createHistory();

const middleware = [];
middleware.push(logger);
middleware.push(routerMiddleware(history));
middleware.push(epicMiddleware);

const configureStore = () => {
  const store = createStore(reducers, applyMiddleware(...middleware));

  if (module.hot) {
    module.hot.accept("../reducers", () => {
      const nextRootReducer = require("../reducers/index");
      store.replaceReducer(nextRootReducer);
    });
  }

  epicMiddleware.run(rootEpic);
  return store;
};

export { configureStore, history };
